/**
 * Default play acceptance windows (Cuba civil time, fixed UTC−5).
 * Default source is Florida; bankers/god can change source and windows adjust.
 */
import { windowsForLotterySource } from '../rules/sourceWindows';

const floridaNow = windowsForLotterySource('florida')!;

export const DEFAULT_WINDOWS = {
  day: { open: floridaNow.dayOpen, close: floridaNow.dayClose },
  night: { open: floridaNow.nightOpen, close: floridaNow.nightClose },
  dayBlock: floridaNow.dayBlock,
  nightBlock: floridaNow.nightBlock,
  /** Day results-wait block length (minutes). */
  resultsGapMinutes: floridaNow.resultsGapMinutes,
  reopenAfterBlockMinutes: floridaNow.reopenAfterBlockMinutes,
};

/** Default minutes before window close at which bets stop being accepted. */
export const DEFAULT_CUTOFF_MINUTES = 1;

/** Configurable cutoff options exposed to bankers (in minutes). */
export const CUTOFF_OPTIONS = [1, 5, 10, 15];

/** Scheduler fires notifications at these offsets before each window close. */
export const SCHEDULER_OFFSETS_MINUTES = [15, 5, 1];

/** Window states used by useCutoffTimer. */
export const WINDOW_STATE = /** @type {const} */ ({
  DAY_OPEN:          'day_open',
  DAY_CLOSED:        'day_closed',
  AWAITING_RESULTS:  'awaiting_results',
  NIGHT_OPEN:        'night_open',
  NIGHT_CLOSED:      'night_closed',
});

/**
 * Supported lottery sources. Bankers select one for result attribution.
 * @type {{ value: string, label: string }[]}
 */
export const LOTTERY_SOURCES = [
  { value: 'classic',  label: 'Classic Bolita' },
  { value: 'florida',  label: 'Florida Lottery' },
  { value: 'georgia',  label: 'Georgia Lottery' },
  { value: 'newyork',  label: 'New York Lottery' },
  { value: 'chicago',  label: 'Chicago Lottery' },
  { value: 'custom',   label: 'Custom' },
];
